/* ==========================================================================
   RAWTORQUE MOBILE DRAWER · v6
   Pairs with rt-mobile-drawer.css and the rt_drawer_block capture in
   sections/header.liquid.
   v6 adds: garage-first menu (fit counts per category via the tiny
   rt-fit-count section), one-tap popular rides, recently viewed, GA4 events.
   Vehicle data and picking come from rt-garage-invite.js (window.RTGarage).
   Every personal feature degrades to the plain v5 menu when data is missing.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__rtDrawerInit) return;
  window.__rtDrawerInit = true;

  var OPEN_CLASS = 'm2a';
  var LS_BRAND   = 'rt_garage_brand';
  var LS_TYPE    = 'rt_garage_type';
  var LS_MODEL   = 'rt_garage_model';
  var LS_RECENT  = 'rt_recent';
  var SS_FIT     = 'rtd_fit:';
  var ENTER_MS   = 900;
  var RECENT_MAX = 8;
  var RECENT_SHOW = 6;
  var DEFAULT_FILTER = 'filter.p.m.custom.compatible_vehicles';

  var html, nav, root, garage, offer, cartCount, fitBox, fitCta, pop, recentBox;
  var enterTimer = 0;
  var fitToken = 0;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(init);

  function init() {
    html = document.documentElement;
    headerLogo();
    nav  = document.getElementById('nav');
    root = nav && nav.querySelector('[data-rtd]');
    if (!root) { recordRecent(); return; }

    garage    = root.querySelector('[data-rtd-garage]');
    offer     = root.querySelector('[data-rtd-offer]');
    cartCount = root.querySelector('[data-rtd-cart-count]');
    fitBox    = root.querySelector('[data-rtd-fit]');
    fitCta    = root.querySelector('[data-rtd-fitcta]');
    pop       = root.querySelector('[data-rtd-pop]');
    recentBox = root.querySelector('[data-rtd-recent]');

    indexEntrance();
    renderGarage();
    renderRecent();
    wireClose();
    wireGarage();
    wireSearch();
    wireAccordions();
    wireCartLink();
    wireRecentClear();
    wireAnalytics();
    wireSwipeToClose();
    wireEscape();
    watchGarage();
    observeDrawerState();

    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart:refresh', refreshCart);
    document.addEventListener('cart:added',   refreshCart);

    /* Warm the fit counts while the page is idle so the drawer opens complete */
    whenIdle(function () { if (vehicle().set) loadFit(); recordRecent(); });

    if (html.classList.contains(OPEN_CLASS)) onOpen();
  }

  /* ── helpers ──────────────────────────────────────────────────────── */
  function readLS(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function whenIdle(fn) {
    var run = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(fn, { timeout: 4000 }); };
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run, { once: true });
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }
  function api() { return window.RTGarage || null; }

  /* ── open / close ─────────────────────────────────────────────────── */
  function closeDrawer() {
    if (typeof window.close_mobile_nav === 'function') { window.close_mobile_nav(); return; }
    html.classList.remove(OPEN_CLASS);
    setTimeout(function () { html.classList.remove('m2a-delay'); }, 360);
  }

  function onOpen() {
    playAvatar();
    renderGarage();
    renderRecent();
    refreshCart();
    nav.scrollTop = 0;
    root.classList.add('is-entering');
    clearTimeout(enterTimer);
    enterTimer = setTimeout(function () { root.classList.remove('is-entering'); }, ENTER_MS);
    track('drawer_open', { has_vehicle: vehicle().set, has_recent: readRecent().length > 0 });
  }

  function onClose() {
    pauseAvatar();
    clearTimeout(enterTimer);
    root.classList.remove('is-entering');
  }

  function observeDrawerState() {
    var was = html.classList.contains(OPEN_CLASS);
    new MutationObserver(function () {
      var now = html.classList.contains(OPEN_CLASS);
      if (now && !was) onOpen();
      if (!now && was) onClose();
      was = now;
    }).observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  function wireClose() {
    var btn = root.querySelector('[data-rtd-close]');
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  }

  function wireEscape() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && html.classList.contains(OPEN_CLASS) && !document.getElementById('rt-gsheet')) closeDrawer();
    });
  }

  function indexEntrance() {
    var i = 0;
    root.querySelectorAll('.rtd-console > *, .rtd-nav > .rtd-list > li').forEach(function (el) {
      el.style.setProperty('--i', Math.min(i++, 10));
    });
  }

  /* ── drawer avatar (waving rider) ─────────────────────────────────── */
  /* One continuous, pre-shuffled performance (wave, idle beats, throttle,
     laugh, visor, pump, look) that loops natively while the drawer is open.
     No seeking between clips: iPhone Safari's slow, inexact seeks caused resets
     mid-move. Each open rewinds to the wave (a single seek while paused);
     closing pauses. Reduced motion, blocked autoplay (iOS Low Power Mode) or a
     failed load keep the still poster. */
  function playAvatar() {
    var v = root.querySelector('.rtd-avatar__video');
    if (!v || !smoothOK()) return;
    if (v.getAttribute('src') && v.paused) { try { v.currentTime = 0; } catch (e) {} }
    playLoop(v, v.parentNode, 'is-playing');
  }

  function pauseAvatar() {
    var v = root.querySelector('.rtd-avatar__video');
    if (v) stopLoop(v);
  }

  /* Shared by the avatar and the header logo.
     - The clip is fetched whole into memory on first use (237 KB / 90 KB) and
       played from a blob: URL, so iOS never stalls on the network mid-move or
       re-requests the file at the loop point (the "stuck" hitch).
     - iOS pauses inline video when the tab is hidden or the screen locks and
       does not always resume it: while the clip is still wanted (drawer open,
       logo on screen) it is restarted on return.
     - The video is revealed only once it is really playing. */
  function playLoop(v, wrap, onClass) {
    v._rtWant = true;
    if (v._rtState === 'ready') { tryPlay(v, wrap, onClass); return; }
    if (v._rtState === 'loading') return;
    v._rtState = 'loading';
    v.loop = true; v.muted = true;
    v.addEventListener('playing', function () { wrap.classList.add(onClass); });
    v.addEventListener('error', function () { wrap.classList.remove(onClass); });
    v.addEventListener('pause', function () {
      setTimeout(function () {
        if (v.paused && v._rtWant && !document.hidden) tryPlay(v, wrap, onClass);
      }, 250);
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && v.paused && v._rtWant) tryPlay(v, wrap, onClass);
    });
    loadWhole(v.getAttribute('data-src'), function (src) {
      v.src = src;
      v._rtState = 'ready';
      if (v._rtWant) tryPlay(v, wrap, onClass);
    });
  }

  function stopLoop(v) {
    v._rtWant = false;
    if (!v.paused) v.pause();
  }

  function tryPlay(v, wrap, onClass) {
    try {
      var p = v.play();
      if (p && p.catch) p.catch(function () { wrap.classList.remove(onClass); });
    } catch (e) {}
  }

  function loadWhole(url, done) {
    if (!window.fetch || !window.URL || !URL.createObjectURL || !window.Blob) { done(url); return; }
    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
      .then(function (b) { done(URL.createObjectURL(b.type ? b : new Blob([b], { type: 'video/mp4' }))); })
      .catch(function () { done(url); });
  }

  /* ── site header logo loop ────────────────────────────────────────── */
  /* Starts after the page has loaded and gone idle (never competes with the
     LCP logo image), loops only while the logo is on screen, and is skipped
     for reduced motion and Data Saver. The <picture> logo stays underneath. */
  function headerLogo() {
    var v = document.querySelector('#logo .rt-hlogo');
    if (!v || !smoothOK()) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var link = v.parentNode;
    whenIdle(function () {
      if (!('IntersectionObserver' in window)) { playLoop(v, link, 'rt-hlogo-on'); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) playLoop(v, link, 'rt-hlogo-on');
          else stopLoop(v);
        });
      }).observe(link);
    });
  }

  /* ── garage ───────────────────────────────────────────────────────── */
  function vehicle() {
    var brand = readLS(LS_BRAND), model = readLS(LS_MODEL), type = readLS(LS_TYPE);
    if (brand === 'Honda Cars') brand = 'Honda';
    var a = api();
    var gids = (brand && a && typeof a.filter === 'function') ? (a.filter() || []) : [];
    return {
      set: !!brand, brand: brand, model: model, type: type === 'car' ? 'car' : 'bike',
      name: brand ? (brand + (model ? ' ' + model : '')) : '',
      short: model || brand,
      gids: gids,
      param: (a && a.filterParam) || DEFAULT_FILTER
    };
  }

  function filterQS(v) {
    return v.gids.map(function (g) { return v.param + '=' + encodeURIComponent(g); }).join('&');
  }
  function withQS(url, qs) { return url + (url.indexOf('?') === -1 ? '?' : '&') + qs; }

  function renderGarage() {
    if (!garage) return;
    var v = vehicle();
    var veh   = garage.querySelector('[data-rtd-garage-veh]');
    var label = garage.querySelector('[data-rtd-garage-label]');
    var act   = garage.querySelector('[data-rtd-garage-act]');

    garage.classList.toggle('is-set', v.set);
    garage.classList.toggle('is-car', v.type === 'car');
    /* Model is what matters, so it gets the big line; brand sits above it */
    if (veh)   veh.textContent   = !v.set ? 'Add your bike or car' : v.short;
    if (label) label.textContent = !v.set ? 'See only parts that fit' : (v.model ? v.brand : 'Shopping for');
    if (act)   act.textContent   = v.set ? 'Change' : 'Add';
    garage.setAttribute('aria-label', v.set
      ? 'My garage: ' + v.name + '. Change vehicle'
      : 'My garage: add your bike or car to see parts that fit');

    renderPopular(v);
    renderFit(v, readFitCache(v));
    renderHelp(v);
  }

  /* ── help: live open/closed status (IST) + WhatsApp with context ──── */
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function fmtHour(h) { return (h % 12 || 12) + (h < 12 ? ' AM' : ' PM'); }

  function renderHelp(v) {
    var st = root.querySelector('[data-rtd-help-st]');
    var tx = st && st.querySelector('[data-rtd-help-st-t]');
    if (st && tx) {
      var open = +st.getAttribute('data-open'), close = +st.getAttribute('data-close');
      var days = (st.getAttribute('data-days') || '').split(',').map(Number);
      var ist = new Date(Date.now() + 330 * 60000);          /* read with getUTC* = IST */
      var d = ist.getUTCDay(), h = ist.getUTCHours() + ist.getUTCMinutes() / 60;
      var workday = days.indexOf(d) > -1;
      var isOpen = workday && h >= open && h < close;
      var when;
      if (!isOpen) {
        if (workday && h < open) when = 'today';
        else {
          var nd = d, k = 0;
          do { nd = (nd + 1) % 7; k++; } while (days.indexOf(nd) < 0 && k < 7);
          when = k === 1 ? 'tomorrow' : DAY_NAMES[nd];
        }
      }
      tx.textContent = isOpen ? 'Open now · till ' + fmtHour(close)
        : 'Closed now · back ' + when + ', ' + fmtHour(open) + ' · message anytime';
      st.classList.add('is-live');
      st.classList.toggle('is-open', isOpen);
    }

    var wa = root.querySelector('[data-rtd-wa]');
    if (wa) {
      var lines = ['Hi Rawtorque team!'];
      if (v && v.set) lines.push((v.type === 'car' ? 'I drive a ' : 'I ride a ') + v.name + '.');
      var og = document.querySelector('meta[property="og:type"]');
      var ot = document.querySelector('meta[property="og:title"]');
      if (og && og.content === 'product' && ot && ot.content) {
        lines.push('Question about: ' + ot.content);
        lines.push(location.origin + location.pathname);
      } else if (location.pathname !== '/') {
        lines.push('I was looking at: ' + location.origin + location.pathname);
      }
      wa.href = 'https://wa.me/' + wa.getAttribute('data-rtd-wa') + '?text=' + encodeURIComponent(lines.join(String.fromCharCode(10)));
    }
  }

  /* rt-garage-invite.js intercepts clicks on #rt-garage-pill in the capture
     phase. This handler only runs where that script is not loaded. */
  function wireGarage() {
    if (!garage) return;
    garage.addEventListener('click', function (e) {
      e.preventDefault();
      var a = api();
      if (a && typeof a.open === 'function') { a.open(); return; }
      closeDrawer();
      setTimeout(function () { window.location.href = '/pages/part-search'; }, 120);
    });
  }

  function watchGarage() {
    document.addEventListener('rt:garage-change', function () { renderGarage(); loadFit(); });
    window.addEventListener('storage', function (e) {
      if (e.key === LS_BRAND || e.key === LS_MODEL || e.key === LS_TYPE) { renderGarage(); loadFit(); }
    });
  }

  /* One-tap popular rides, only while no vehicle is saved */
  function renderPopular(v) {
    if (!pop) return;
    var a = api();
    var list = a && a.popular && typeof a.set === 'function' ? a.popular : [];
    if (v.set || !list.length) { pop.hidden = true; return; }
    var row = pop.querySelector('[data-rtd-pop-row]');
    if (row && !row.childElementCount) {
      row.innerHTML = list.map(function (p, i) {
        return '<button type="button" class="rtd-popchip" data-rtd-pop-i="' + i + '">' + esc(p[0]) + '</button>';
      }).join('');
      row.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-rtd-pop-i]');
        if (!chip) return;
        var p = list[parseInt(chip.getAttribute('data-rtd-pop-i'), 10)];
        if (!p) return;
        track('drawer_garage_set', { vehicle: p[2] + ' ' + p[3], source: 'popular' });
        a.set(p[1], p[2], p[3]);   /* fires rt:garage-change → renderGarage + loadFit */
      });
    }
    pop.hidden = false;
  }

  /* ── fit list ─────────────────────────────────────────────────────── */
  /* Source items come from the server-rendered accordion marked
     data-rtd-src="bike" (Shop by Category) or "car" (Shop by Car). */
  function fitSource(v) {
    var li = root.querySelector('.rtd-list > li[data-rtd-src="' + v.type + '"]');
    if (!li) return null;
    var items = [];
    li.querySelectorAll('.rtd-tile, .rtd-sub').forEach(function (a) {
      var t = a.querySelector('.rtd-tile__t');
      var url = a.getAttribute('href') || '';
      if (url.indexOf('/collections/') !== 0) return;
      items.push({ title: (t ? t.textContent : a.textContent).trim(), url: url.split('?')[0] });
    });
    return { li: li, items: items };
  }

  function fitKey(v) { return SS_FIT + v.gids.slice().sort().join('|'); }
  function readFitCache(v) {
    if (!v.set || !v.gids.length) return null;
    try { return JSON.parse(sessionStorage.getItem(fitKey(v)) || 'null'); } catch (e) { return null; }
  }

  function countFrom(url) {
    return fetch(withQS(url, 'section_id=rt-fit-count'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = t.match(/data-rt-count="(\d+)"/); return m ? parseInt(m[1], 10) : null; })
      .catch(function () { return null; });
  }

  function loadFit() {
    var v = vehicle();
    if (!v.set || !v.gids.length || !window.fetch) { renderFit(v, null); return; }
    if (readFitCache(v)) { renderFit(v, readFitCache(v)); return; }
    var src = fitSource(v);
    var qs = filterQS(v);
    var token = ++fitToken;
    var jobs = [countFrom(withQS('/collections/all', qs))];
    (src ? src.items : []).forEach(function (it) { jobs.push(countFrom(withQS(it.url, qs))); });
    Promise.all(jobs).then(function (res) {
      if (token !== fitToken) return;
      var data = { total: res[0], counts: {} };
      (src ? src.items : []).forEach(function (it, i) { data.counts[it.url] = res[i + 1]; });
      /* Only cache real answers; null means the count section isn't installed */
      if (res[0] !== null) { try { sessionStorage.setItem(fitKey(v), JSON.stringify(data)); } catch (e) {} }
      renderFit(vehicle(), data);
    });
  }

  function renderFit(v, data) {
    if (!fitBox) return;
    var src = v.set ? fitSource(v) : null;
    root.querySelectorAll('.rtd-list > li[data-rtd-hide]').forEach(function (li) { li.removeAttribute('data-rtd-hide'); });

    /* Nothing fits (or no data to work with): keep the normal menu */
    if (!v.set || !src || !src.items.length || !v.gids.length || (data && data.total === 0)) {
      root.classList.remove('is-fit');
      fitBox.hidden = true; fitBox.innerHTML = '';
      renderFitCta(v, data);
      return;
    }

    var qs = filterQS(v);
    var counts = data ? data.counts : null;
    var known = counts && src.items.some(function (it) { return typeof counts[it.url] === 'number'; });
    var items = src.items.slice();
    var zeros = [];
    if (known) {
      zeros = items.filter(function (it) { return counts[it.url] === 0; });
      items = items.filter(function (it) { return counts[it.url] !== 0; })
        .sort(function (a, b) { return (counts[b.url] || 0) - (counts[a.url] || 0); });
    }

    var rows = items.map(function (it) {
      var n = counts ? counts[it.url] : undefined;
      var badge = n === undefined ? '<span class="rtd-skel" aria-hidden="true"></span>'
        : typeof n === 'number' ? '<span class="rtd-fitn" aria-label="' + n + ' fit">' + n + '</span>' : '';
      return '<li><a class="rtd-row" href="' + esc(withQS(it.url, qs + '&sort_by=best-selling')) + '" data-rtd-ev="fit" data-rtd-n="' + (typeof n === 'number' ? n : '') + '">' +
        '<span class="rtd-row__t">' + esc(it.title) + '</span>' + badge +
        '<svg class="rtd-row__go" viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a></li>';
    }).join('');

    var other = '';
    if (zeros.length) {
      other = '<ul class="rtd-list"><li class="rtd-acc">' +
        '<button type="button" class="rtd-row" aria-expanded="false" aria-controls="rtd-p-other" data-rtd-acc>' +
          '<span class="rtd-row__t">Other categories</span><span class="rtd-row__n">' + zeros.length + '</span>' +
          '<svg class="rtd-row__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="rtd-panel" id="rtd-p-other" role="region" aria-label="Other categories"><div class="rtd-panel__in"><ul class="rtd-sublist">' +
          zeros.map(function (it) { return '<li><a class="rtd-sub" href="' + esc(it.url) + '">' + esc(it.title) + '</a></li>'; }).join('') +
        '</ul></div></div></li></ul>';
    }

    fitBox.innerHTML =
      '<p class="rtd-fit__h">Fits your <b>' + esc(v.short) + '</b></p>' +
      '<ul class="rtd-list">' + rows + '</ul>' + other +
      '<p class="rtd-fit__more">More to explore</p>';
    fitBox.hidden = false;
    src.li.setAttribute('data-rtd-hide', '');
    root.classList.add('is-fit');
    renderFitCta(v, data);
  }

  function renderFitCta(v, data) {
    if (!fitCta) return;
    if (!v.set || !v.gids.length) { fitCta.hidden = true; return; }
    var label = fitCta.querySelector('[data-rtd-fitcta-t]');
    var total = data ? data.total : null;
    fitCta.classList.toggle('is-empty', total === 0);
    if (total === 0) {
      var wa = root.querySelector('.rtd-btn--wa');
      var base = wa ? wa.getAttribute('href').split('?')[0] : 'https://wa.me/919446514691';
      fitCta.href = base + '?text=' + encodeURIComponent('Hi Rawtorque team, I need parts for my ' + v.name);
      fitCta.target = '_blank'; fitCta.rel = 'noopener';
      fitCta.setAttribute('data-rtd-ev', 'fit_ask');
      if (label) label.textContent = 'Ask us about parts for your ' + v.short;
    } else {
      fitCta.href = withQS('/collections/all', filterQS(v) + '&sort_by=best-selling');
      fitCta.removeAttribute('target'); fitCta.removeAttribute('rel');
      fitCta.setAttribute('data-rtd-ev', 'fit_all');
      if (label) label.textContent = typeof total === 'number'
        ? 'Shop ' + total.toLocaleString('en-IN') + ' part' + (total === 1 ? '' : 's') + ' that fit'
        : 'Shop parts that fit';
    }
    fitCta.hidden = false;
  }

  /* ── search: hand off to the theme's search overlay ───────────────── */
  function wireSearch() {
    var btn = root.querySelector('[data-rtd-search]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
      setTimeout(function () {
        var toggle = document.querySelector('#header-outer [aria-controls="search"],.link-btn a[aria-controls="search"],a.search-compact[href="#search"]');
        if (toggle) { toggle.click(); return; }
        var searchEl = document.getElementById('search');
        var field = searchEl && searchEl.querySelector('input[type="search"]');
        if (searchEl) searchEl.classList.add('full', 'has-text');
        if (field) { html.classList.add('search-compact-active', 'search-full'); field.focus(); }
        else window.location.href = '/search';
      }, 320);
    });
  }

  /* ── accordions (delegated, one open at a time) ───────────────────── */
  function wireAccordions() {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rtd-acc]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var li = btn.closest('.rtd-acc');
      var willOpen = !li.classList.contains('is-open');
      root.querySelectorAll('.rtd-acc.is-open').forEach(function (other) {
        if (other === li) return;
        other.classList.remove('is-open');
        var b = other.querySelector('[data-rtd-acc]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      li.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        setTimeout(function () { keepInView(li); }, 320);
      }
    });
  }

  function keepInView(li) {
    var bar = root.querySelector('.rtd-bar');
    var barH = bar ? bar.offsetHeight : 0;
    var navRect = nav.getBoundingClientRect();
    var r = li.getBoundingClientRect();
    var bottomOver = r.bottom - navRect.bottom + 80;
    var topRoom = r.top - navRect.top - barH;
    if (bottomOver > 0) {
      var delta = Math.min(bottomOver, topRoom - 4);
      if (delta > 0) nav.scrollBy({ top: delta, behavior: smoothOK() ? 'smooth' : 'auto' });
    }
  }
  function smoothOK() {
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ── recently viewed ──────────────────────────────────────────────── */
  function readRecent() {
    try { var l = JSON.parse(readLS(LS_RECENT) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* On product pages, remember the product (title, image, price) on the phone */
  function recordRecent() {
    var handle = currentHandle();
    if (!handle || !window.fetch || window.__rtdRecorded) return;
    window.__rtdRecorded = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.title) return;
        var item = { h: p.handle || handle, t: p.title, i: p.featured_image || '', p: p.price || 0 };
        var list = [item].concat(readRecent().filter(function (x) { return x && x.h !== item.h; })).slice(0, RECENT_MAX);
        try { localStorage.setItem(LS_RECENT, JSON.stringify(list)); } catch (e) {}
      })
      .catch(function () {});
  }

  function renderRecent() {
    if (!recentBox) return;
    var here = currentHandle();
    var list = readRecent().filter(function (x) { return x && x.h && x.h !== here; }).slice(0, RECENT_SHOW);
    if (!list.length) { recentBox.hidden = true; return; }
    var row = recentBox.querySelector('[data-rtd-recent-row]');
    row.innerHTML = list.map(function (x, i) {
      var img = x.i ? x.i + (x.i.indexOf('?') === -1 ? '?' : '&') + 'width=240' : '';
      var price = x.p ? '₹' + Math.round(x.p / 100).toLocaleString('en-IN') : '';
      return '<a class="rtd-rcard" href="/products/' + esc(encodeURIComponent(x.h)) + '" data-rtd-ev="recent" data-rtd-pos="' + (i + 1) + '">' +
        '<span class="rtd-rcard__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="116" height="116" loading="lazy" decoding="async">' : '') + '</span>' +
        '<span class="rtd-rcard__t">' + esc(x.t) + '</span>' +
        (price ? '<span class="rtd-rcard__p">' + price + '</span>' : '') +
      '</a>';
    }).join('');
    recentBox.hidden = false;
  }

  function wireRecentClear() {
    var btn = root.querySelector('[data-rtd-recent-clear]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      try { localStorage.removeItem(LS_RECENT); } catch (err) {}
      recentBox.hidden = true;
      track('drawer_recent_clear');
    });
  }

  /* ── GA4: one delegated listener, never blocks navigation ─────────── */
  function wireAnalytics() {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || !root.contains(a)) return;
      var ev = a.getAttribute('data-rtd-ev');
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
      var v = vehicle();
      if (ev === 'fit') {
        track('drawer_fit_click', { category: a.querySelector('.rtd-row__t').textContent, fit_count: a.getAttribute('data-rtd-n'), vehicle: v.name });
      } else if (ev === 'fit_all' || ev === 'fit_ask') {
        track('drawer_fit_click', { category: ev === 'fit_all' ? 'all' : 'ask_whatsapp', vehicle: v.name });
      } else if (ev === 'recent') {
        track('drawer_recent_click', { position: Number(a.getAttribute('data-rtd-pos')) || 0, item: text });
      } else {
        var area = a.closest('.rtd-dock') ? 'dock' : a.closest('.rtd-help') ? 'help'
          : a.closest('.rtd-brands') ? 'brand' : ev === 'order' ? 'order' : 'menu';
        track('drawer_nav_click', { area: area, item: text });
      }
    });
  }

  /* ── cart: dock badge + offer progress ────────────────────────────── */
  function wireCartLink() {
    var link = root.querySelector('[data-rtd-cart]');
    if (!link || !link.hasAttribute('data-panel')) return;
    link.addEventListener('click', function () { closeDrawer(); });
  }

  function refreshCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart.item_count || 0); })
      .catch(function () {});
  }

  function renderCart(count) {
    if (cartCount) {
      var prev = parseInt(cartCount.textContent, 10) || 0;
      cartCount.textContent = count;
      cartCount.hidden = count === 0;
      if (count > prev) {
        cartCount.classList.remove('is-pop');
        void cartCount.offsetWidth;
        cartCount.classList.add('is-pop');
      }
    }
    if (!offer) return;
    var target = parseInt(offer.getAttribute('data-target'), 10) || 3;
    var left = Math.max(target - count, 0);
    offer.classList.toggle('is-done', left === 0);
    offer.querySelectorAll('.rtd-offer__bar i').forEach(function (seg, i) {
      seg.classList.toggle('is-on', i < count);
    });
    var status = offer.querySelector('[data-rtd-offer-status]');
    if (status) {
      status.textContent = left === 0 ? 'Applied at checkout'
        : count === 0 ? target + ' to go'
        : left + ' more to go';
    }
  }

  /* ── swipe left to close ──────────────────────────────────────────── */
  function wireSwipeToClose() {
    var startX = 0, startY = 0, dx = 0, dragging = false, axis = null;
    nav.addEventListener('touchstart', function (e) {
      if (window.innerWidth > 1000 || !html.classList.contains(OPEN_CLASS)) return;
      if (e.target.closest('.rtd-brands__scroll, .rtd-recent__row, .rtd-pop__row')) return;   /* let rows scroll */
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; dx = 0; dragging = true; axis = null;
    }, { passive: true });
    nav.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var t = e.touches[0];
      dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis !== 'x' || dx >= 0) return;
      nav.style.transition = 'none';
      nav.style.transform = 'translateX(' + Math.max(dx, -160) + 'px)';
    }, { passive: true });
    function end() {
      if (!dragging) return;
      dragging = false;
      nav.style.transition = '';
      nav.style.transform = '';
      if (axis === 'x' && dx <= -70) closeDrawer();
    }
    nav.addEventListener('touchend', end);
    nav.addEventListener('touchcancel', end);
  }

})();
